import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCurrentMembership } from '../lib/organisation/useCurrentMembership';
import { formatPersonName } from '../lib/people/personName';
import { useMyProfile } from '../lib/profile/useMyProfile';
import { initialsFrom } from '../lib/text/initials';

/**
 * Header account chip — name + role, green live dot, opens Settings.
 */
export function HeaderProfile() {
  const { t } = useTranslation(['layout', 'common']);
  const { data: profile } = useMyProfile();
  const { membership } = useCurrentMembership();
  const displayName = formatPersonName(
    profile,
    membership?.name ?? t('brand.accountFallback'),
  );
  const roleLabel = membership ? t(`common:roles.${membership.role}`) : t('common:roles.member');

  return (
    <Link
      to="/settings"
      title={t('header.settings')}
      aria-label={t('header.profileLabel', { name: displayName, role: roleLabel })}
      className="hidden items-center gap-2.5 rounded-xl py-1 ps-1 pe-2.5 no-underline transition-colors hover:bg-[var(--gs-panel2)] lg:flex"
      style={{ color: 'var(--gs-ink)' }}
    >
      <span
        className="relative grid h-9 w-9 shrink-0 place-items-center rounded-full text-[13.5px] font-bold"
        style={{ background: 'var(--gs-accent-solid)', color: '#fff' }}
        aria-hidden
      >
        {initialsFrom(displayName)}
        <span
          title={t('header.realtimeConnected')}
          className="absolute -bottom-px -end-px h-[11px] w-[11px] rounded-full border-2"
          style={{
            background: 'var(--gs-ok)',
            borderColor: 'var(--gs-panel)',
          }}
        />
      </span>
      <span className="flex min-w-0 flex-col gap-px">
        <span className="truncate text-sm font-bold leading-tight whitespace-nowrap">
          {displayName}
        </span>
        <span
          className="truncate text-xs leading-tight whitespace-nowrap"
          style={{ color: 'var(--gs-muted)' }}
        >
          {roleLabel}
        </span>
      </span>
    </Link>
  );
}
